import { render, staticRenderFns } from "./BulmaToast.vue?vue&type=template&id=a703a462"
import script from "./BulmaToast.vue?vue&type=script&lang=js"
export * from "./BulmaToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a703a462')) {
      api.createRecord('a703a462', component.options)
    } else {
      api.reload('a703a462', component.options)
    }
    module.hot.accept("./BulmaToast.vue?vue&type=template&id=a703a462", function () {
      api.rerender('a703a462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaToast/BulmaToast.vue"
export default component.exports